import React,{useState} from 'react';
import stylePreventivo from './Preventivo.module.scss';
import { Button, Modal, Spin } from 'antd';
import Immagine from '../../components/Immagine/Immagine';
import { useSelector } from 'react-redux';


const Preventivo = (props) => {

    const [visibleModal,setVisibleModal] = useState(false);
    const uuid = useSelector(state => state.dataReducer.modello.id);
    const progressivoSimulazione = useSelector(state => state.dataReducer.modello.progressivoSimulazione);
    const errorPreventivo = useSelector(state => state.dataReducer.errorePreventivo.dati);
    //const tmpCurrentStep = useSelector(state => state.dataReducer.tmpCurrentStep);
    const apiPath = useSelector(state => state.dataReducer.dataApiPath);

    const pathSecci = apiPath === null ? `/.rest/api/v1/` : apiPath;

    const disablePreventivo = errorPreventivo ? true : false;

    const importo = applicaSeparatore(props.importo);
    const tan = convertNumberFloat(props.tan);
    const taeg = convertNumberFloat(props.taeg);
    const rata = convertNumberFloat(props.rata);
    //const dispatch = useDispatch();

    function showModal(){
        setVisibleModal(!visibleModal);
    }

    function convertNumberFloat(number){
        return ((number).toFixed(2)).replace('.',',');
    }

    function applicaSeparatore(importoNumerico){  
        let importo = importoNumerico.toString();  
        if(importo.length > 3){  
            importo = importo.split('',importo.length).reverse().join('').replace(/([0-9]{3})/g,'$1.');  
            importo = importo.split('',importo.length).reverse().join('');  
        }  
        return importo;  
    } 

    return (
        <div className={stylePreventivo.Preventivo}>
            <Spin spinning={props.spin}>
            <h1 className={stylePreventivo.Titolo}>La soluzione che hai scelto</h1>
            <div className={stylePreventivo.contenutiLeft}>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>Importo</h2>
                    <p className={stylePreventivo.risultatoInfo}>{importo}€</p>
                </div>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>Durata</h2>
                    <p className={stylePreventivo.risultatoInfo}>{props.numeroRate} mesi</p>
                </div>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>Assicurazione</h2>
                    <p className={stylePreventivo.risultatoInfo}>
                        { props.assicurazione === true ? 'Si' : 'No' }
                    </p>
                </div>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>TAN</h2>
                    <p className={stylePreventivo.risultatoInfo}>{tan}%</p>
                </div>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>TAEG</h2>
                    <p className={stylePreventivo.risultatoInfo}>{taeg}%</p>
                </div>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>Rata</h2>
                    <p className={stylePreventivo.risultatoInfo}>{rata}€/mese</p>
                    {props.assicurazione ? (
                        <p className={stylePreventivo.risultatoInfoPremio}>Include il premio, le imposte e le commissioni per gli intermediari.</p>
                    ): null}
                </div>

            </div>
            <div className={stylePreventivo.contenutiRight}>

                <div className={stylePreventivo.buttonSecci}>
                    <a target='_self' href={`${pathSecci}downloadDocumento/${progressivoSimulazione}`} className={stylePreventivo.linkSecci} download><Immagine urlImage={'preventivatore/yellow.svg'} name='open' /><span>Modulo SECCI</span></a>
                    <Immagine urlImage={'petroil.svg'} name="info" clicked={showModal} class={stylePreventivo.openInfo} />
                </div>

                <Button htmlType='submit' className={stylePreventivo.buttonAvanti} loading={props.loadingStep} disabled={disablePreventivo}>
                    {uuid === null ? `Richiedi finanziamento`: `Riprendi finanziamento`} <Immagine urlImage={'right.svg'} name='go' />
                </Button>

            </div>

            <div className={stylePreventivo.Clear}></div>


            <Modal
                onCancel={showModal}
                open={visibleModal}
                closeIcon={<Immagine urlImage={'close-modal.svg'} name='close' />}
            >
                <h2>Attenzione</h2>
                <p>In questa fase possiamo fornirti un SECCI impostato esclusivamente in base alle preferenze da te manifestate. La concessione del finanziamento è soggetta a valutazione e approvazione di Prestipay S.p.A.</p>
            </Modal>

            </Spin>
        </div>
    )
}

export default Preventivo;